import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import confetti from 'canvas-confetti';
import './styles.css';

function Demo() {
  const [participants] = useState([
    { id: 1, name: 'Viewer_123', joinedAt: new Date() },
    { id: 2, name: 'GameLover', joinedAt: new Date() },
    { id: 3, name: 'StreamFan', joinedAt: new Date() },
    { id: 4, name: 'LuckyViewer', joinedAt: new Date() },
    { id: 5, name: 'GiveawayHero', joinedAt: new Date() }
  ]);
  const [isRandomizing, setIsRandomizing] = useState(false);
  const [currentRandomName, setCurrentRandomName] = useState('');
  const [showWheel, setShowWheel] = useState(false);
  const [winner, setWinner] = useState(null);
  const [spinItems, setSpinItems] = useState([]);
  const [spinPosition, setSpinPosition] = useState(0);

  const fireConfetti = () => {
    const duration = 3000;
    const end = Date.now() + duration;

    const frame = () => {
      confetti({
        particleCount: 2,
        angle: 60,
        spread: 55,
        origin: { x: 0 },
        colors: ['#ff4d4d', '#f6366f', '#2d1b69']
      });
      confetti({
        particleCount: 2,
        angle: 120,
        spread: 55,
        origin: { x: 1 },
        colors: ['#ff4d4d', '#f6366f', '#2d1b69']
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    };
    frame();
  };

  const generateSpinItems = (participants, count = 50) => {
    const items = [];
    for (let i = 0; i < count; i++) {
      const randomParticipant = participants[Math.floor(Math.random() * participants.length)];
      items.push(randomParticipant);
    }
    return items;
  };

  const handlePickWinner = async () => {
    setIsRandomizing(true);
    setShowWheel(true);
    setWinner(null);
    
    const items = generateSpinItems(participants);
    setSpinItems(items);
    
    setSpinPosition(0);
    await new Promise(resolve => setTimeout(resolve, 100));
    setSpinPosition(-8000);
    
    try {
      await new Promise(resolve => setTimeout(resolve, 8000));
      const randomWinner = participants[Math.floor(Math.random() * participants.length)];
      setCurrentRandomName(randomWinner.name);
      await new Promise(resolve => setTimeout(resolve, 500));
      fireConfetti();
      setWinner(randomWinner);
      await new Promise(resolve => setTimeout(resolve, 1500));
    } catch (error) {
      console.error('Error picking winner:', error);
    } finally {
      setIsRandomizing(false);
      setShowWheel(false);
    }
  };

  return (
    <div className="demo-container">
      <div className="demo-header">
        <h1>Trải nghiệm Give Away</h1>
        <p>Xem cách hoạt động của hệ thống quay thưởng</p>
      </div>

      <div className="demo-content">
        <div className="demo-stats">
          <div className="demo-stat-item">
            <i className="fas fa-users"></i>
            <div>
              <strong>{participants.length}</strong>
              <span>Người tham gia</span>
            </div>
          </div>
          {/* Thêm các stats khác nếu cần */}
        </div>

        <div className="demo-participants">
          {participants.map(participant => (
            <div key={participant.id} className="demo-participant">
              <div className="demo-participant-info">
                <i className="fas fa-user"></i>
                <span>{participant.name}</span>
              </div>
              <span className="demo-join-time">
                {participant.joinedAt.toLocaleTimeString()}
              </span>
            </div>
          ))}
        </div>

        {showWheel && (
          <div className="wheel-container">
            <div className="wheel-content">
              <div className="spin-track">
                <div 
                  className="spin-items"
                  style={{ transform: `translateX(${spinPosition}px)` }}
                >
                  {spinItems.map((participant, index) => (
                    <div 
                      key={index} 
                      className={`spin-item participant`}
                    >
                      <div className="participant-avatar">
                        <i className="fas fa-user"></i>
                      </div>
                      <div className="participant-name">{participant.name}</div>
                    </div>
                  ))}
                </div>
                <div className="spin-marker"></div>
              </div>
            </div>
          </div>
        )}

        {winner ? (
          <div className="winner-animation">
            <i className="fas fa-trophy me-2"></i>
            <div>
              <strong>🎉 Chúc mừng:</strong> {winner.name}
            </div>
          </div>
        ) : (
          <button 
            className="btn-pick-winner"
            onClick={handlePickWinner}
            disabled={isRandomizing}
          >
            {isRandomizing ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Đang chọn người may mắn...
              </>
            ) : (
              <>
                <i className="fas fa-gift me-2"></i>
                Chọn người may mắn
              </>
            )}
          </button>
        )}
      </div>

      <div className="demo-cta">
        <h2>Thích thú với trải nghiệm demo?</h2>
        <p>Hãy tạo phòng Give Away của riêng bạn ngay bây giờ!</p>
        <Link to="/create-room" className="btn btn-light btn-lg">
          <i className="fas fa-rocket me-2"></i>
          Bắt Đầu Ngay - Miễn Phí
        </Link>
      </div>
    </div>
  );
}

export default Demo; 